import React from "react";
import { FileDownloadOutlined } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

interface AttachmentsComponentProps {
  documentName: string;
  documentType?: string;
  onDownload?: () => void;
  onPreview?: () => void;
  langBase: string;
  hideDocumentType?: boolean;
}

const AttachmentsComponent: React.FC<AttachmentsComponentProps> = ({
  documentName,
  documentType,
  onDownload,
  onPreview,
  langBase,
  hideDocumentType = false,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      {!hideDocumentType && (
        <Typography variant="body1" className="break-all text-gray-700">
          {documentType ?? t(`${langBase}.attachments`)}
        </Typography>
      )}
      <div className="border rounded p-4 w-full border-[#F1F2F4] mt-2">
        <div className="flex justify-start items-center mb-2 w-full gap-24">
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline break-all cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              if (onPreview) {
                onPreview();
              }
            }}
          >
            {documentName}
          </a>
          <button
            onClick={onDownload}
            className="cursor-pointer text-left ml-auto"
            title="Download"
          >
            <FileDownloadOutlined />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AttachmentsComponent;
